import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import styles from './index.module.scss';
import { ReactComponent as RadioCheckedIcon } from '../../../../../../../assets/icons/radioChecked.svg';
import { ReactComponent as RadioUncheckedIcon } from '../../../../../../../assets/icons/radioUnchecked.svg';
import EMRPatientInfo from './EMRPatientInfo';
import { IEMRPatient } from '../../../../../../../services/intakeDataService/emrPatientsService/types';

const EMRPatientResult = ({
  selected,
  patient,
  onChange,
}: {
  selected?: number;
  patient: IEMRPatient;
  onChange(id?: number): void;
}) => {
  const patientId = patient?.patientId;
  return (
    <div
      className={classNames(
        styles.emrResult,
        'flex items-center cursor-pointer gap-x-4',
        {
          [styles.selected]: selected === patientId,
        },
      )}
      onClick={() => onChange(patientId)}
    >
      {selected === patientId ? <RadioCheckedIcon /> : <RadioUncheckedIcon />}
      <EMRPatientInfo {...patient} />
    </div>
  );
};

export default observer(EMRPatientResult);
